import CoursePlanStatusUpdateEvent from './CoursePlanStatusUpdateEvent';
export default CoursePlanStatusUpdateEvent;
